import React from 'react'
import PropTypes from 'prop-types'
import { Layout } from 'antd'

const { Content } = Layout

const PageContent = ({ children }) => {
  return (
    <Content
      className="site-layout-background"
      style={{
        padding: 24,
        minHeight: 280
      }}
    >
      {children}
    </Content>
  )
}

PageContent.propTypes = {
  children: PropTypes.node
}

export default PageContent
